
<template>
    <v-dialog v-model="dialog" width="800px">
        <v-card flat>
            <v-card-title class="justify-center">{{ priptaal.title }}</v-card-title>
            <v-divider/>
            <v-card-text>
                <v-row class="pa-2">
                    <v-col cols="3">Type</v-col>
                    <v-col cols="9">{{ priptaal.priptaal_veld_oms }}</v-col>
                    <v-col cols="3">Language</v-col>
                    <v-col cols="9">{{ priptaal.priptaal_taal_code }}</v-col>
                    <v-col cols="3">Text value</v-col>
                    <v-col cols="9"><v-textarea v-model="priptaal.priptaal_waarde" label="Enter a text" dense></v-textarea></v-col>
                </v-row>
                <v-divider/>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="primary" @click="savePripTaal">Save</v-btn>
                <v-btn color="error"   @click="closePripTaal">Cancel</v-btn>
            </v-card-actions>
        </v-card>  
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        data() {
            return {
                dialog: false,
                priptaal : {
                    title: "",
                    priptaal_encrid: "",
                    priptaal_veld_oms: "",
                    priptaal_taal_code: "",
                    priptaal_waarde: ""
                },
            }  
        },
        methods: {
            openEditPripTaal(priptaal_encrid, priptaal_veld_oms) {
                this.$axios.post("ares/json/ares/syst/prip/getPripTaal.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPripTaal"
                    },
                    getPripTaal: {
                        priptaal_veld_oms: priptaal_veld_oms,
                        priptaal_encrid: priptaal_encrid
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.priptaal =  res.data.getPripTaal
                        this.dialog = true
                    }
                });
            },
            savePripTaal() {
                this.$axios.post("ares/json/ares/syst/prip/savePripTaal.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "savePripTaal"
                    },
                    savePripTaal: {
                        priptaal: this.priptaal
                    }
                }).then(res => {
                    if (res.data.error) {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.savePripTaal.text,
                            color: res.data.savePripTaal.color
                        });
                        if (res.data.savePripTaal.color === "success") {
                            this.$emit("reload")
                            this.closePripTaal()
                        }
                    }
                });
            },
            closePripTaal() {
                this.dialog = false
            }
        }
    };
</script> 

<style scoped>
</style>